import { Slider, LiveRoomCard } from '../../components';

import css from './ListingPage.module.css';

// slidesToShow
const SLIDES_TO_SHOW_TABLET = 2;
const SLIDES_TO_SHOW_DESKTOP = 2;
// slidesToScroll
const SLIDES_TO_SCROLL_TABLET = 2;
const SLIDES_TO_SCROLL_DESKTOP = 2;

const SectionLiveRoomsMaybe = props => {
  const { intl, liveRooms, queryShowLiveRoomsInProgress, queryShowLiveRoomsError } = props;

  if (queryShowLiveRoomsInProgress || queryShowLiveRoomsError) {
    return null;
  }

  const hasLiveRooms = liveRooms.length > 0;
  const sliderTitle = intl.formatMessage({ id: 'ListingPage.liveRoomsTitle' });

  return hasLiveRooms ? (
    <div className={css.sectionExperiences}>
      <div className={css.liveRooms}>
        <Slider
          id="ListingPage.ExperiencesSlider"
          headerClassName={css.sliderHeader}
          titleClassName={css.liveRoomsTitle}
          title={sliderTitle}
          slidesToShow={{
            tablet: SLIDES_TO_SHOW_TABLET,
            desktop: SLIDES_TO_SHOW_DESKTOP,
          }}
          slidesToScroll={{
            tablet: SLIDES_TO_SCROLL_TABLET,
            desktop: SLIDES_TO_SCROLL_DESKTOP,
          }}
        >
          {liveRooms.map(e => {
            return <LiveRoomCard key={e.id.uuid} listing={e} />;
          })}
        </Slider>
      </div>
    </div>
  ) : null;
};

export default SectionLiveRoomsMaybe;
